export class HhsgSharedUserApplicationModel {
    id: number;
    clientId: number;
    clientName: string;
    userId: number;
    childApplicationUserId: number;
    applicationId: number;
    applicationName: string;
    applicationIsActive: boolean;
    isActive: boolean;
    customClaims: string;
    displayRole: string;
    applicationAbbreviation: string;
    hasChildApplicationLoginPermission: boolean;
    upsertMessage: string;
}
